import { Pointer } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { imageBaseApi } from "../../services/imageBaseApi";


const AustralianSVG = ({setHoveredLetter,isMobile,data }) => {
 
  const router = useNavigate();
  console.log(data)
 
  return (
    <>
    
    {!isMobile ?(
   
      <div className="d-flex align-items-end " >
      <img
        src={imageBaseApi+data?.[0]?.media?.url}
        style={{ width: "50%", marginRight:"6rem",   transform: "translate(0, -31px)", }}
        alt="Australia"
        
      />

     <svg
  id="Layer_1"
  data-name="Layer 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 832.64 216.69"
  width="150%"
  style={{flexShrink:"0"}}
  onMouseEnter={()=>{setHoveredLetter("A1");}}
  onMouseLeave={()=>setHoveredLetter(null)}
>
  <g transform="translate(0, 5)">

  {/* Large Heading */}
<foreignObject
  x="0.94"
  y="-8"
  width="500"    // set your desired fixed width
  height="200"   // set enough height for all lines
>
  <div
    xmlns="http://www.w3.org/1999/xhtml"
    style={{
      fontFamily: "Proxima Nova Black, Proxima Nova",
      fontSize: "52px",
      fontWeight: 800,
      color: data?.[0]?.titleColor,
      lineHeight: "1",
      wordWrap: "break-word",
    }}
  >

  {data?.[0]?.title?.split("/n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ))}



  </div>
</foreignObject>

  {/* Subheading */}
<foreignObject
  x="0.94"
  y="154.3"
  width="500"
  height="100"
>
  <div
    xmlns="http://www.w3.org/1999/xhtml"
    style={{
      fontFamily: "Proxima Nova Regular, Proxima Nova",
      fontSize: "20px",
      color: "black",
      lineHeight: "1.1",
      wordWrap: "break-word",
    }}
  >
     {data?.[0]?.subTitle?.split("/n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ))}
  </div>
</foreignObject>


  {/* Explore Opportunities Group */}
  <g style={{ cursor: "pointer" }} onClick={() => router(data?.[0]?.buttonUrl)}>
  {/* Invisible rect covering the clickable area */}
  <rect
    x={0}       // adjust to match your SVG coordinates
    y={0}
    width={900} // set width to cover entire g area
    height={150} // set height to cover entire g area
    fill="transparent"
  />

  <text
    transform="translate(629.87 119.27)"
    style={{
      fill: "#ff3500",
      fontFamily: "Proxima Nova Bold, Proxima Nova",
      fontSize: 18.83,
      fontWeight: 700,
    }}
  >
    <tspan x="0" y="0">EXP</tspan>
    <tspan x="35.32" y="0" style={{ letterSpacing: "-0.03em" }}>L</tspan>
    <tspan x="44.5" y="0">ORE</tspan>
    <tspan x="0" y="22.59">OPPO</tspan>
    <tspan x="52.33" y="22.59" style={{ letterSpacing: "0em" }}>R</tspan>
    <tspan x="64.25" y="22.59">TUNITIES</tspan>
  </text>

  <path
    d="M797.66,89.74h-206.29c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33h-42.49c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23h0c0-18.9-15.32-34.23-34.23-34.23Z"
    fill="none"
    stroke="#ff3500"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</g>

  </g>
</svg>


    </div>):  
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 662.01 173.55"
  
   
    >

       
       
       
      {/* Headline */}
     <foreignObject
  x="0.94"
  y="1.67"        // match the y from your <text> transform
  width="500"      // set your desired width
  height="200"     // enough height for all lines
>
  <div
    xmlns="http://www.w3.org/1999/xhtml"
    style={{
      fontFamily: "Proxima Nova Black, Proxima Nova",
      fontSize: "38px",        // match your <text> font size
      fontWeight: 800,
      color: data?.[0]?.titleColor,
      lineHeight: "1.05",      // adjust line spacing
      display: "flex",
        backgroundColor: "transparent", 
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      margin: 0,
      padding: 0,
    }}
       onClick={() => console.log("clicked!")}
  >
    {data?.[0]?.title?.split("/n")}
  </div>
</foreignObject>


      {/* Description */}
       <foreignObject
  x="0"
  y="110.61"
  width="360"
  height="120"
>
  <div
    xmlns="http://www.w3.org/1999/xhtml"
    style={{
      fontFamily: "Proxima Nova Regular",
      fontSize: "22px",
      color: "black",
      lineHeight: "1.1",
      wordWrap: "break-word",
    }}
  >
    {data?.[0]?.subTitle?.split("/n").map((line, index) => (
      <div key={index} style={{ lineHeight: "1.05" }}>
        {line}
      </div>
    ))}
  </div>
</foreignObject>

      {/* Button */}
      <g transform="translate(0 45)" style={{cursor:"pointer"}} onClick={()=>router(data?.[0]?.buttonUrl)}>
        <text
          transform="translate(459.25 94.94)"
          style={{
            fontFamily: "Proxima Nova Bold",
            fontSize: "18.83px",
            fontWeight: 700,
            fill: data?.[0]?.buttonColor,
          }}
        >
      
            {data?.[0]?.buttonText?.split("/n").map((line, index) => (
    <tspan key={index} x="0" y={index === 0 ? "-10" : 18.83 * index - 10}>
      {line}
    </tspan>
  ))}
        
        </text>

        <path
          d="M627.03,53.15h-206.29c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33h-42.49c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23s-15.32-34.23-34.23-34.23Z"
          style={{
            fill: "none",
            stroke: data?.[0]?.buttonColor,
            strokeWidth: "1.5px",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </g>
     
    </svg>}
    </>
  );
};

export default AustralianSVG;
